import React from 'react'
import TweenOne from 'rc-tween-one'
import BezierPlugin from 'rc-tween-one/lib/plugin/BezierPlugin'
import './add-cart.less'
TweenOne.plugins.push(BezierPlugin)
export const AddCart = ({
  dom,
  onStop,
}: {
  dom: HTMLElement
  onStop: () => void
}) => {
  const WIDTH = window.innerWidth
  const src = (dom.querySelector('img') as HTMLImageElement).src
  const offsetTop = (dom.getBoundingClientRect() as any).y
  return (
    <TweenOne
      animation={{
        bezier: {
          type: 'soft',
          autoRotate: false,
          vars: [
            { x: 0, y: 0 },
            {
              x: WIDTH * 0,
              y: -offsetTop * 0.14,
            },
            {
              x: WIDTH * 0.09,
              y: -offsetTop * 0.62,
            },
            {
              x: WIDTH - dom.offsetWidth / 2,
              y: -offsetTop - dom.offsetHeight / 2,
            },
          ],
        },
        onComplete: onStop,
        duration: 500,
      }}
      className="add-carting"
      style={{
        top: `${offsetTop}px`,
        left: '10px',
      }}
    >
      <TweenOne
        animation={{
          scale: 0.4,
          duration: 500,
        }}
      >
        <img src={src} alt="" />
      </TweenOne>
    </TweenOne>
  )
}
